import { twMerge } from 'tailwind-merge';
import { useFile, useFileVersionFromFileId } from '@witmetrics/data-store';
import { useLoadedFiles } from '@/providers/LoadedFilesProvider';
import FileCategoryIcon from '@/components/FileCategoryIcon';
import { classes } from './utils';

export type ItemImageProps = {
  fileId: number;
  dense?: boolean;
};

export default function ItemImage({ fileId, dense }: ItemImageProps) {
  const file = useFile(fileId);
  const fileVersion = useFileVersionFromFileId(fileId);
  const { loadedFiles } = useLoadedFiles();

  if (!file) return null;

  const preview = fileVersion
    ? loadedFiles[`preview-${fileVersion.id}`]
    : undefined;

  return preview ? (
    <div
      className={twMerge(classes.imgWrapper, dense && classes.imgWrapperDense)}>
      <img className={classes.img} alt={file.name} src={preview as string} />
    </div>
  ) : (
    <FileCategoryIcon file={file} size={dense ? 'sm' : 'base'} />
  );
}
